import { useMutation, gql } from '@apollo/client'

const useDeleteProcessInvoiceLater = (onSuccess) => {
  const [deleteProcessInvoiceLater, { loading, error }] = useMutation(
    gql`
      mutation ($invoiceId: String!) {
        deleteProcessInvoiceLater (invoiceId: $invoiceId)
      }
    `
  )
  return [deleteProcessInvoiceLater, { loading, error }]
}

export default useDeleteProcessInvoiceLater